import {  ThumbnailImagePath } from "../constants/commonConstants";
export const getThumbnailImagePath = (filePath) => {
    try{
        let fileExtension = filePath?.split(/[#?]/)[0].split(".").pop().trim().toLowerCase();
        switch (fileExtension) {
          case "pdf":
            return ThumbnailImagePath.Pdf;
          case "doc":
          case "docx":
            return ThumbnailImagePath.Doc;
          case "xls":
          case "xlsx":
          case "csv":
            return ThumbnailImagePath.Excel;
          default:
            return filePath;
        }
    }
    catch{
        return filePath
    }
  };


export const getFileExtension = (filePath) => {
  try {
    if (!filePath) return null;
    const ext = filePath.split(/[#?]/)[0].split('.').pop().trim().toLowerCase();
    return ext ? `.${ext}` : null;
  } catch {
    return null;
  }
};
